import { type ReactNode } from "react";
import { useField } from "formik";

import {
  CheckboxControl,
  type CheckboxControlType,
} from "@vega-core/components/Form/Controls/Checkbox/CheckboxControl";
import { useTouchFieldOnSubmit } from "@vega-core/helpers/formik.helper";
import { isTruthy } from "@vega-core/utils/isTruthy";

export type CheckboxFieldProps = {
  label?: ReactNode | string;
  name: string;
  type?: CheckboxControlType;
  className?: string;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
  fullWidth?: boolean;
};

export function CheckboxField({
  label,
  name,
  type,
  className,
  disabled,
  onChange,
  fullWidth,
}: CheckboxFieldProps) {
  const [field, meta, helpers] = useField<boolean>(name);
  useTouchFieldOnSubmit(name);

  const handleCheckedChange = async (checked: boolean) => {
    await helpers.setValue(checked);
    onChange && onChange(checked);
  };

  return (
    <CheckboxControl
      checked={field.value}
      className={className}
      disabled={disabled}
      error={meta.touched && isTruthy(meta.error) ? meta.error : undefined}
      fullWidth={fullWidth}
      label={label}
      name={name}
      onBlur={field.onBlur}
      onChange={handleCheckedChange}
      type={type}
    />
  );
}
